import Icon from '../components/Icon.vue'

Icon.register({
  clipboard: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 112v352c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h80c0-35.3 28.7-64 64-64s64 28.7 64 64h80c26.5 0 48 21.5 48 48zM192 40c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM288 154v-20c0-3.3-2.7-6-6-6h-180c-3.3 0-6 2.7-6 6v20c0 3.3 2.7 6 6 6h180c3.3 0 6-2.7 6-6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/clipboard.js
// module id = 1201
// module chunks = 0